module.exports = __webpack_public_path__ + "media/components/assets/icons/live_red-969fe7beaf6b526c63526d4127ac2692.svg";